import {
  Component,
  OnInit,
  HostListener,
  Input,
  OnDestroy,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { MessageService, SelectItem, MenuItem } from 'primeng/api';
import { Confirm_button } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Observable, interval, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Store, select } from '@ngrx/store';
import { UserService } from '../../services/user.service';
import * as fromStore from '../../store';
import * as fromFeature from '../../my-features';

import { SummaryService } from '../../services/summary.service';
import { summaryCharType, summaryEventType, summaryEventNumber, PackageList } from '../../shareModel';
import { EventsParams } from '../../models/events';
import * as moment from 'moment';
import { ShareModule } from 'src/app/modules/share/share.module';
import { PreferenceService } from '../../services/preference.service';

@Component({
  standalone: false,
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css'],
})
export class SummaryComponent implements OnInit, OnDestroy {
  @Input() showSummary;
  @Input() selectedLanguage;
  summaryRangeOptions: any[] = [
    { label: this.translateService.instant('7 days'), value: 0 , disabled : false},
    { label: this.translateService.instant('30 days'), value: 1 , disabled : false},
  ];
  summaryDateRange: any;
  summarySelectedRangeOptions: any = 0;
  summaryWeeklyDataList: any;
  summaryMonthlyDataList: any;
  chartWeeklyDonutOptions: any;
  chartWeeklyDonutEmpty = false;
  warningChartWeeklyOptions: any;
  warningChartMonthlyDonutOptions: any;
  warningChartMonthlyOptions: any;
  criticalChartWeeklyOptions: any;
  chartMonthlyDonutOptions: any;
  chartMonthlyDonutEmpty = false;
  criticalChartMonthlyOptions: any;
  warningWeeklyOptions: any;
  warningMonthlyOptions: any;
  criticalWeeklyOptions: any;
  criticalMonthlyOptions: any;
  last7Time: any;
  last30Time: any;
  startDateBy7Days: any;
  startDateBy30Days: any;
  endDate: any;
  endTime: any;
  timezone: any;

  Confirm_button = Confirm_button;
  // planAccountInfo: any;
  packageEventSummary = false;
  private componentDestroyed = new Subject();
  alertweeklySummary = false;
  alertmonthlySummary = true;
  last7daysflag = true;
  last30daysflag = false;
  userModuleStateData: any;

  scrollPanelHeight: number;
  toggleClass = false;
  displayConfirmDialog = false;
  isMsp = false;

  constructor(
    private router: Router,
    private userService: UserService,
    private store: Store<fromStore.State>,
    private summaryService: SummaryService,
    private translateService: TranslateService,
    private preferenceService: PreferenceService
  ) {
    this.translateService.onLangChange
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        // SummaryRange Translate
        this.summaryRangeOptions[0].label =
          this.translateService.instant('7 days');
        this.summaryRangeOptions[1].label =
          this.translateService.instant('30 days');
        if (this.chartWeeklyDonutOptions !== undefined) {
          // ChartWeeklyDonutOptions
          this.chartWeeklyDonutOptions.labels[0] =
            this.translateService.instant('Utility Power Failed');
          this.chartWeeklyDonutOptions.labels[1] =
            this.translateService.instant('Enabling Buck');
          this.chartWeeklyDonutOptions.labels[2] =
            this.translateService.instant('Enabling Boost');
          this.chartWeeklyDonutOptions.labels[3] =
            this.translateService.instant('Overload');
        }
        if (this.chartWeeklyDonutOptions !== undefined) {
          // ChartMonthlyDonutOptions
          this.chartMonthlyDonutOptions.labels[0] =
            this.translateService.instant('Utility Power Failed');
          this.chartMonthlyDonutOptions.labels[1] =
            this.translateService.instant('Enabling Buck');
          this.chartMonthlyDonutOptions.labels[2] =
            this.translateService.instant('Enabling Boost');
          this.chartMonthlyDonutOptions.labels[3] =
            this.translateService.instant('Overload');
        }
      });

    this.store
    .select(fromStore.getSummary)
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe((res) => {
      if (res.Loaded && !res.Loading) {
        // Summary Info分Last7days&Last30days
        this.initSummaryContent('weekly', res.entities.weekly_data);
        this.initSummaryContent('monthly', res.entities.monthly_data);
        // 紀錄當下Last7days與Last30days起訖時間,以便detail取資料
        this.startDateBy7Days = Number(res.entities.last_7_days_ts) * 1000;
        this.startDateBy30Days = Number(res.entities.last_30_days_ts) * 1000;
        this.endDate = Number(res.entities.end_ts) * 1000;
        // 取得當下時區
        // tslint:disable-next-line:max-line-length
        this.timezone = moment(Number(res.entities.last_7_days_ts) * 1000).utcOffset() > 0 ? '+' + (moment(Number(res.entities.last_7_days_ts) * 1000).utcOffset() / 60) : (moment(Number(res.entities.last_7_days_ts) * 1000).utcOffset()) / 60;
        // 紀錄當下顯示Info為Last7days或Last30days
        this.last7Time = moment(this.startDateBy7Days).format('MM/DD');
        this.last30Time = moment(this.startDateBy30Days).format('MM/DD');
        this.endTime = moment(this.endDate).format('YYYY/MM/DD');
      }
    });

    // Get isMsp
    this.store.select(fromStore.getIsMsp).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res !== null) {
        this.isMsp = res;
      }
    });

    this.store.select(fromStore.getUserModuleState).subscribe((res) => {
      if (!res.Loading && res.Loaded) {
        this.userModuleStateData = res.entities && typeof res.entities === 'object'
          ? { ...res.entities }
          : res.entities;
      }
    });

    this.store.select(fromStore.getIsActiveUserModule, PackageList.EventSummary).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.packageEventSummary = Boolean(res);
      if (!this.packageEventSummary) {
        this.summaryRangeOptions = [
          { label: this.translateService.instant('7 days'), value: 0 , disabled : false},
          { label: this.translateService.instant('30 days'), value: 1 , disabled : true},
        ];
      }
    });
  }

  ngOnInit() {
    this.scrollPanel();
  }

  selectedTimeRange(event) {
    if (event.value === 0) {
      // 這邊放weekly資料
      this.alertweeklySummary = false;
      this.alertmonthlySummary = true;
      this.last7daysflag = true;
      this.last30daysflag = false;
    } else {
      // show出Alert
      if (!this.packageEventSummary) {
        this.alertweeklySummary = true;
        this.alertmonthlySummary = true;
      } else {
        // 這邊放monthly資料
        this.alertweeklySummary = true;
        this.alertmonthlySummary = false;
        this.last7daysflag = false;
        this.last30daysflag = true;
      }
    }
  }

  initSummaryContent(type, item) {
    if (type === summaryCharType.weekly) {
      const seriesWeeklyWarningChar = [];
      const seriesWeeklyCriticalChar = [];
      if (
        item.WarningEventChart !== undefined &&
        Object.keys(item.WarningEventChart).length !== 0
      ) {
        [...item.WarningEventChart].sort(function (a: any, b: any) {
          return a.x - b.x;
        }).map((i: { x: number; y: any }) => {
          // 整理WarningEvent格式,供series使用
          const date = new Date(i.x * 1000);
          seriesWeeklyWarningChar.push([date, i.y]);
        });
      }

      if (
        item.CriticalEventChart !== undefined &&
        Object.keys(item.CriticalEventChart).length !== 0
      ) {
        [...item.CriticalEventChart].sort(function (a: any, b: any) {
          return a.x - b.x;
        }).map((i: { x: number; y: any }) => {
          // 整理CriticalEvent格式,供series使用
          const date = new Date(i.x * 1000);
          seriesWeeklyCriticalChar.push([date, i.y]);
        });
      }

      // Status Count
      this.summaryWeeklyDataList = [
        {
          title: 'Warning Event',
          number:
            item.WarningEventCount !== undefined ? item.WarningEventCount : 0,
        },
        {
          title: 'Critical Event',
          number:
            item.CriticalEventCount !== undefined ? item.CriticalEventCount : 0,
        },
        {
          title: 'Number of Device',
          number:
            item.DeviceNumberCount !== undefined ? item.DeviceNumberCount : 0,
        },
        {
          title: 'Utility Power Failed',
          number:
            item.UtilityPowerFailedCount !== undefined
              ? item.UtilityPowerFailedCount
              : 0,
          color: '#fdc503',
        },
        {
          title: 'Enabling Buck',
          number: item.BuckCount !== undefined ? item.BuckCount : 0,
          color: '#fdb703',
        },
        {
          title: 'Enabling Boost',
          number: item.BoostCount !== undefined ? item.BoostCount : 0,
          color: '#fd8e03',
        },
        {
          title: 'Overload',
          number: item.OverloadCount !== undefined ? item.OverloadCount : 0,
          color: '#d51f35',
        },
      ];

      // WarningChart
      this.warningChartWeeklyOptions = {
        series: [
          {
            name: '',
            data: seriesWeeklyWarningChar,
          },
        ],
        chart: {
          width: '100%',
          height: 50,
          type: 'area',
          sparkline: {
            enabled: true,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          // enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          opacity: 0.3,
        },
        title: {
          enabled: false,
        },
        xaxis: {
          type: 'datetime',
          crosshairs: {
            width: 1,
          },
          categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        },
        yaxis: {
          stepSize: 1,
          decimalsInFloat: 0
        },
        tooltip: {
          fixed: {
            enabled: false,
          },
          x: {
            show: false,
          },
          y: {
            formatter: function(val) {
              return Math.floor(val).toString(); 
            },
            title: {
              formatter: function (seriesName) {
                return '';
              },
            },
          },
        },
      };

      // CriticalChart
      this.criticalChartWeeklyOptions = {
        series: [
          {
            name: '',
            data: seriesWeeklyCriticalChar,
          },
        ],
        chart: {
          width: '100%',
          height: 50,
          type: 'area',
          sparkline: {
            enabled: true,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          // enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          opacity: 0.3,
        },
        title: {
          enabled: false,
        },
        xaxis: {
          type: 'datetime',
          crosshairs: {
            width: 1,
          },
          categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        },
        yaxis: {
          stepSize: 1,
          decimalsInFloat: 0
        },
        tooltip: {
          fixed: {
            enabled: false,
          },
          x: {
            show: false,
          },
          y: {
            formatter: function(val) {
              return Math.floor(val).toString(); 
            },
            title: {
              formatter: function (seriesName) {
                return '';
              },
            },
          },
        },
      };
      this.chartWeeklyDonutOptions = {
        // device char
        series:
          item.DeviceNumberChart !== undefined ? item.DeviceNumberChart : [],
        chart: {
          type: 'donut',
          width: '100%',
          height: 140,
        },
        // pie name
        labels: [
          this.translateService.instant('Utility Power Failed'),
          this.translateService.instant('Enabling Buck'),
          this.translateService.instant('Enabling Boost'),
          this.translateService.instant('Overload'),
        ],
        colors: ['#fdc503', '#fdb703', '#fd8e03', '#d51f35'],
        dataLabels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
            colors: ['#000000', '#000000', '#000000', '#000000'],
          },
          dropShadow: {
            enabled: false,
            top: 1,
            left: 1,
            blur: 1,
            color: '#000',
            opacity: 0.45,
          },
        },
        stroke: {
          colors: ['#f0f0f0'],
        },
        legend: {
          show: false,
        },
        noData: {
          text: undefined,
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined,
          },
        },
      };

      const arrChartWeeklyDonut = this.chartWeeklyDonutOptions.series;
      // tslint:disable-next-line: no-shadowed-variable
      const chartWeeklyDonutIsAllZero = arrChartWeeklyDonut.every((item: number) => item === 0);
      this.chartWeeklyDonutEmpty = chartWeeklyDonutIsAllZero;

      this.warningWeeklyOptions = {
        colors: ['#fdc503'],
      };

      this.criticalWeeklyOptions = {
        colors: ['#d51f35'],
      };
    } else {
      this.summaryDateRange = '';
      const seriesMonthlyWarningChar = [];
      const seriesMonthlyCriticalChar = [];
      if (
        item.WarningEventChart !== undefined &&
        Object.keys(item.WarningEventChart).length !== 0
      ) {
        [...item.WarningEventChart].sort(function (a: any, b: any) {
          return a.x - b.x;
        }).map((i: { x: number; y: any }) => {
          // 整理WarningEvent格式,供series使用
          const date = new Date(i.x * 1000);
          seriesMonthlyWarningChar.push([date, i.y]);
        });
      }

      if (
        item.CriticalEventChart !== undefined &&
        Object.keys(item.CriticalEventChart).length !== 0
      ) {
        [...item.CriticalEventChart].sort(function (a: any, b: any) {
          return a.x - b.x;
        }).map((i: { x: number; y: any }) => {
          // 整理CriticalEvent格式,供series使用
          const date = new Date(i.x * 1000);
          seriesMonthlyCriticalChar.push([date, i.y]);
        });
      }

      // WarningChar
      this.warningChartMonthlyOptions = {
        series: [
          {
            name: '',
            data: seriesMonthlyWarningChar,
          },
        ],
        chart: {
          width: '100%',
          height: 50,
          type: 'area',
          sparkline: {
            enabled: true,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          opacity: 0.3,
        },
        title: {
          enabled: false,
        },
        xaxis: {
          type: 'datetime',
          crosshairs: {
            width: 1,
          },
          categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        },
        yaxis: {
          decimalsInFloat: 0,
          labels: {
            formatter: function (val) {
              return val !== null && val !== undefined ? val.toFixed(0) : val;
            },
          },
        },
        tooltip: {
          x: { show: true, format: 'dd MMM' },
          y: {
            formatter: function (val) {
              return val !== null && val !== undefined ? val.toFixed(0) : val;
            },
            title: {
              formatter: function (seriesName) {
                return '';
              },
            },
          },
        },
      };

      // CriticalChar
      this.criticalChartMonthlyOptions = {
        series: [
          {
            name: '',
            data: seriesMonthlyCriticalChar,
          },
        ],
        chart: {
          width: '100%',
          height: 50,
          type: 'area',
          sparkline: {
            enabled: true,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          opacity: 0.3,
        },
        title: {
          enabled: false,
        },
        xaxis: {
          type: 'datetime',
          crosshairs: {
            width: 1,
          },
          categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        },
        yaxis: {
          decimalsInFloat: 0,
          labels: {
            formatter: function (val) {
              return val !== null && val !== undefined ? val.toFixed(0) : val;
            },
          },
        },
        tooltip: {
          x: { show: true, format: 'dd MMM' },
          y: {
            formatter: function (val) {
              return val !== null && val !== undefined ? val.toFixed(0) : val;
            },
            title: {
              formatter: function (seriesName) {
                return '';
              },
            },
          },
        },
      };

      this.summaryMonthlyDataList = [
        {
          title: 'Warning Event',
          number:
            item.WarningEventCount !== undefined ? item.WarningEventCount : 0,
        },
        {
          title: 'Critical Event',
          number:
            item.CriticalEventCount !== undefined ? item.CriticalEventCount : 0,
        },
        {
          title: 'Number of Device',
          number:
            item.DeviceNumberCount !== undefined ? item.DeviceNumberCount : 0,
        },
        {
          title: 'Utility Power Failed',
          number:
            item.UtilityPowerFailedCount !== undefined
              ? item.UtilityPowerFailedCount
              : 0,
          color: '#fdc503',
        },
        {
          title: 'Enabling Buck',
          number: item.BuckCount !== undefined ? item.BuckCount : 0,
          color: '#fdb703',
        },
        {
          title: 'Enabling Boost',
          number: item.BoostCount !== undefined ? item.BoostCount : 0,
          color: '#fd8e03',
        },
        {
          title: 'Overload',
          number: item.OverloadCount !== undefined ? item.OverloadCount : 0,
          color: '#d51f35',
        },
      ];
      this.chartMonthlyDonutOptions = {
        series:
          item.DeviceNumberChart !== undefined ? item.DeviceNumberChart : [],
        chart: {
          type: 'donut',
          width: '100%',
          height: 140,
        },
        labels: [
          this.translateService.instant('Utility Power Failed'),
          this.translateService.instant('Enabling Buck'),
          this.translateService.instant('Enabling Boost'),
          this.translateService.instant('Overload'),
        ],
        colors: ['#fdc503', '#fdb703', '#fd8e03', '#d51f35'],
        dataLabels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
            colors: ['#000000', '#000000', '#000000', '#000000'],
          },
          dropShadow: {
            enabled: false,
            top: 1,
            left: 1,
            blur: 1,
            color: '#000',
            opacity: 0.45,
          },
        },
        stroke: {
          colors: ['#f0f0f0'],
        },
        legend: {
          show: false,
        },
        radiusBackground: {
          color: '#d1d1d1' // Set your color per instance if you like
        },
        noData: {
          text: undefined,
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined,
          },
        },
      };

      const arrChartMonthlyDonut = this.chartMonthlyDonutOptions.series;
      // tslint:disable-next-line: no-shadowed-variable
      const chartMonthlyDonutIsAllZero = arrChartMonthlyDonut.every((item: number) => item === 0);
      this.chartMonthlyDonutEmpty = chartMonthlyDonutIsAllZero;

      this.warningMonthlyOptions = {
        colors: ['#fdc503'],
      };

      this.criticalMonthlyOptions = {
        colors: ['#d51f35'],
      };
    }
  }

  showSummaryDetail(item) {
    if (!this.isMsp && (!this.packageEventSummary)) {
      this.displayConfirmDialog = true;
    } else {
      if (
        this.userModuleStateData != null &&
        this.userModuleStateData['Event Summary']['Value'] === '1'
      ) {
        this.summaryService.SetSummaryEndDate = this.endDate;
        // 判斷Detail要取得7天前或30天前資料來顯示
        if (this.summarySelectedRangeOptions === 1) {
          this.summaryService.SetSummaryStartDate = this.startDateBy30Days;
        } else {
          this.summaryService.SetSummaryStartDate = this.startDateBy7Days;
        }
        // 還原預設值
        this.summaryService.SetSummaryStatus = null;
        this.summaryService.SetSummaryEvent = null;
        // Warning & Critical 傳入參數為status
        if (item.title === summaryEventType.Warning) {
          this.summaryService.SetSummaryStatus = summaryEventNumber.Warning;
        } else if (item.title === summaryEventType.Critical) {
          this.summaryService.SetSummaryStatus =
            summaryEventNumber.Critical;
        } else if (item.title === summaryEventType.Utility) {
          // 其餘傳入參數為event
          this.summaryService.SetSummaryEvent = summaryEventNumber.Utility;
        } else if (item.title === summaryEventType.Buck) {
          this.summaryService.SetSummaryEvent = summaryEventNumber.Buck;
        } else if (item.title === summaryEventType.Boost) {
          this.summaryService.SetSummaryEvent = summaryEventNumber.Boost;
        } else if (item.title === summaryEventType.Overload) {
          this.summaryService.SetSummaryEvent = summaryEventNumber.Overload;
        }
        // 另開新頁
        // window.open('/event-summary');
        // 20240911改為原分頁開啟
        this.router.navigate(['/event-summary']);
      }
    }
  }

  purchaseRouter(): void {
    this.router.navigate(['/purchase']);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.scrollPanel();
  }

  scrollPanel() {
    this.scrollPanelHeight = self.innerHeight - 120;
  }

  toggleSummary() {
    const div = document.getElementById('DashBoradSummary');
    const appMainContent = document.getElementById('appMainContent');
    const ContactUsBtn = document.getElementById('ContactUs');
    if (div.classList.contains('showSummaryContent')) {
      div.classList.remove('showSummaryContent');
      appMainContent.classList.remove('margin');
      ContactUsBtn.classList.remove('margin');
    } else {
      div.classList.add('showSummaryContent');
      appMainContent.classList.add('margin');
      ContactUsBtn.classList.remove('margin');
      ContactUsBtn.classList.add('margin');
    }
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.unsubscribe();
    const ContactUsBtn = document.getElementById('ContactUs');
    ContactUsBtn.classList.remove('margin');
  }
}
